import type { CustomerOption, DisputePriorityOption, UserOption } from '@/hooks/useDisputesData';

/**
 * Mock dispute priority options for demo mode
 */
export const mockDisputePriorities: DisputePriorityOption[] = [
  { id: 4, code: 'Low', name: 'Low', sortOrder: 4 },
  { id: 3, code: 'Medium', name: 'Medium', sortOrder: 3 },
  { id: 2, code: 'High', name: 'High', sortOrder: 2 },
  { id: 1, code: 'Critical', name: 'Critical', sortOrder: 1 },
];

/**
 * Mock customer options for demo mode
 */
export const mockCustomerOptions: CustomerOption[] = [
  { id: 1, name: 'Acme Corporation' },
  { id: 2, name: 'TechStart Inc' },
  { id: 3, name: 'Global Solutions Ltd' },
  { id: 4, name: 'Enterprise Systems Co' },
  { id: 5, name: 'Innovate Labs' },
];

/**
 * Mock user options for demo mode
 */
export const mockUserOptions: UserOption[] = [
  { id: 1, name: 'John Smith' },
  { id: 2, name: 'Sarah Johnson' },
  { id: 3, name: 'Mike Chen' },
  { id: 4, name: 'Emily Davis' },
  { id: 5, name: 'David Wilson' },
];
